import PCAccordionIcon from '../../components/icons/builder/PCAccordionIcon';
import PCBlogIcon from '../../components/icons/builder/PCBlogIcon';
import PCDividerIcon from '../../components/icons/builder/PCDividerIcon';
import PCFormIcon from '../../components/icons/builder/PCFormIcon';
import PCGoogleAdIcon from '../../components/icons/builder/PCGoogleAdIcon';
import PCGoogleMapIcon from '../../components/icons/builder/PCGoogleMapIcon';
import PCHeaderIcon from '../../components/icons/builder/PCHeaderIcon';
import PCHtmlIcon from '../../components/icons/builder/PCHtmlIcon';
import PCIcon from '../../components/icons/builder/PCIcon';
import PCImageCarouselIcon from '../../components/icons/builder/PCImageCarouselIcon';
import PCImageGalleryIcon from '../../components/icons/builder/PCImageGalleryIcon';
import PCImageIcon from '../../components/icons/builder/PCImageIcon';
import PCListIcon from '../../components/icons/builder/PCListIcon';
import PCMediaCarouselIcon from '../../components/icons/builder/PCMediaCarouselIcon';
import PCMediaObjectIcon from '../../components/icons/builder/PCMediaObjectIcon';
import PCMenuIcon from '../../components/icons/builder/PCMenuIcon';
import PCParagraphIcon from '../../components/icons/builder/PCParagraphIcon';
import PCProgressIcon from '../../components/icons/builder/PCProgressIcon';
import PCRentMyIcon from '../../components/icons/builder/PCRentMyIcon';
import PCSiteLogoIcon from '../../components/icons/builder/PCSiteLogoIcon';
import PCSocialIconIcon from '../../components/icons/builder/PCSocialIconIcon';
import PCTabIcon from '../../components/icons/builder/PCTabIcon';
import PCTestimonialIcon from '../../components/icons/builder/PCTestimonialIcon';
import PCTextDividerIcon from '../../components/icons/builder/PCTextDividerIcon';
import PCVideoIcon from '../../components/icons/builder/PCVideoIcon';
import PCButtonIcon from './../../components/icons/builder/PCButtonIcon';

const componentList = [
    {
        name: 'Heading',
        type: 'heading',
        icon: PCHeaderIcon,
        category: 'basic',
        keywords: 'title headline header caption',
        hasMedia: false,
        mediaInfo: null,
    },
    {
        name: 'Paragraph',
        type: 'paragraph',
        icon: PCParagraphIcon,
        category: 'basic',
        keywords: 'text	paragraph body content',
        hasMedia: false,
        mediaInfo: null,
    },
    {
        name: 'Button',
        type: 'button',
        icon: PCButtonIcon,
        category: 'basic',
        keywords: 'link call-to-action CTA button',
        hasMedia: false,
        mediaInfo: null,

    },
    {
        name: 'Image',
        type: 'image',
        icon: PCImageIcon,
        category: 'basic',
        keywords: 'picture image graphic photo',
        hasMedia: true,
        mediaInfo: {
            path: 'url',
            isArray: false
        },

    },
    {
        name: 'Video',
        type: 'video',
        icon: PCVideoIcon,
        category: 'basic',
        keywords: 'video media clip	film footage',
        hasMedia: true,
        mediaInfo: {
            path: 'src',
            isArray: false
        },

    },
    {
        name: 'Image Carousel',
        type: 'image-carousel',
        icon: PCImageCarouselIcon,
        category: 'advance',
        keywords: 'image carousel slider slideshow gallery rotation',
        hasMedia: true,
        mediaInfo: {
            path: 'items',
            isArray: true,
        },

    },
    {
        name: 'Media Carousel',
        type: 'media-carousel',
        icon: PCMediaCarouselIcon,
        category: 'advance',
        keywords: 'video slider carousel slider slideshow mixed media gallery',
        hasMedia: true,
        mediaInfo: {
            path: 'items',
            isArray: true,
        },

    },
    {
        name: 'Divider',
        type: 'divider',
        icon: PCDividerIcon,
        category: 'basic',
        keywords: 'divider line separation break',
        hasMedia: false,
        mediaInfo: null,
    },
    {
        name: 'Text Divider',
        type: 'text-divider',
        icon: PCTextDividerIcon,
        category: 'basic',
        keywords: 'text-divider divider  separator line break',
        hasMedia: false,
        mediaInfo: null,


    },
    {
        name: 'List',
        type: 'list',
        icon: PCListIcon,
        category: 'basic',
        keywords: 'list bullet points enumeration items',
        hasMedia: false,
        mediaInfo: null,

    },

    {
        name: 'Accordion',
        type: 'accordion',
        icon: PCAccordionIcon,
        category: 'advance',
        keywords: 'accordion collapsible toggle expand',
        hasMedia: false,
        mediaInfo: null,

    },

    {
        name: 'Testimonial',
        type: 'testimonial',
        icon: PCTestimonialIcon,
        category: 'advance',
        keywords: 'testimonial feedback	review endorsement',
        hasMedia: true,
        mediaInfo: {
            path: 'items',
            isArray: true,
        },

    },
    {
        name: 'Media Object',
        type: 'mediaObject',
        icon: PCMediaObjectIcon,
        category: 'advance',
        keywords: 'media object multimedia mixed media content block',
        hasMedia: true,
        mediaInfo: {
            path: 'items',
            isArray: true,
        },


    },

    {
        name: 'Image Gallery',
        type: 'image-gallery',
        icon: PCImageGalleryIcon,
        category: 'advance',
        keywords: 'masonry gallery image photo picture graphic',
        hasMedia: true,
        mediaInfo: {
            path: 'items',
            isArray: true,
        },
    },

    {
        name: 'Form',
        type: 'form',
        icon: PCFormIcon,
        category: 'advance',
        keywords: 'form input survey questionnaire',
        hasMedia: false,
        mediaInfo: null,

    },

    {
        name: 'Site Logo',
        type: 'sitelogo',
        icon: PCSiteLogoIcon,
        category: 'basic',
        keywords: 'site logo brand identity emblem',
        hasMedia: false,
        mediaInfo: null,

    },

    {
        name: 'Menus',
        type: 'menus',
        icon: PCMenuIcon,
        category: 'basic',
        keywords: 'menus navigation	links bar',
        hasMedia: false,
        mediaInfo: null,

    },

    {
        name: 'Blog',
        type: 'blog-grid',
        icon: PCBlogIcon,
        category: 'advance',
        keywords: 'blog articles posts news',
        hasMedia: false,
        mediaInfo: null,

    },

    {
        name: 'RentMy Products',
        type: 'rentmy',
        icon: PCRentMyIcon,
        category: 'advance',
        keywords: 'rentmy products rental leasing equipment',
        hasMedia: false,
        mediaInfo: null,

    },

    {
        name: 'Social Icon',
        type: 'social-icon',
        icon: PCSocialIconIcon,
        category: 'basic',
        keywords: 'social icon social media share network',
        hasMedia: true,
        mediaInfo: {
            path: 'icons',
            isArray: true,
        },


    },
    {
        name: 'Icon',
        type: 'icon',
        icon: PCIcon,
        category: 'basic',
        keywords: 'icon symbol glyph emblem',
        hasMedia: false,
        mediaInfo: null,

    },
    {
        name: 'HTML',
        type: 'html',
        icon: PCHtmlIcon,
        category: 'advance',
        keywords: 'html css js javascript code markup website language'

    },
    {
        name: 'Google Map',
        type: 'google-map',
        icon: PCGoogleMapIcon,
        category: 'advance',
        keywords: 'google map location directions',
        hasMedia: false,
        mediaInfo: null,

    },
    {
        name: 'Progress',
        type: 'progress',
        icon: PCProgressIcon,
        category: 'basic',
        keywords: 'progress bar	status completion',
        hasMedia: false,
        mediaInfo: null,

    },
    {
        name: 'Google Adsense',
        type: 'google-adsense',
        icon: PCGoogleAdIcon,
        category: 'advance',
        keywords: 'google adsense advertising revenue monetization',
        hasMedia: false,
        mediaInfo: null,


    },
    {
        name: 'Tab',
        type: 'tab',
        icon: PCTabIcon,
        category: 'advance',
        keywords: 'tab section panel category',
        hasMedia: false,
        mediaInfo: null,

    },



];

export default componentList;

